// App.js
import React, { useEffect } from "react";
import { BrowserRouter as Router, Route, Switch, Redirect } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import Home from "./Home";
import CoursesPage from "./CoursesPage";
import TutoringPage from "./TutoringPage";
import LessonDetails from "./LessonDetails";
import Navbar from "./Navbar";
import Footer from './Footer';
import AuthCallback from "./AuthCallback";
import '@fortawesome/fontawesome-free/css/all.min.css';
import { LanguageProvider } from "./LanguageContext";
import Payment from "./Payment";
import PremiumPage from "./PremiumPage";
import Auth0ProviderWrapper from "./Auth0Provider"; // ✅ New import
import Quiz from "./components/Quiz"; // adjust the path if needed
import { financialGoalsQuestions } from "./questions/financialGoalsQuestions";
//import guides from "./GuidesFiles";   // The list of all guides
import GuidesPage from "./GuidesPage";       // The dynamic content page
import BlogGuides from "./BlogGuides";
import PersonalFinance from "./PersonalFinance";
import StockTradingBasics from "./StockTradingBasics"
import InvestParaBr from "./InvestparaBr";
import PaymentInvestEua from "./PaymentInvestEua";
import RetirementCalculator from "./RetirementCalculator";
import CareersPage from "./CareersPage";


const App = () => {
  // const { isAuthenticated, getAccessTokenSilently } = useAuth0();

  // useEffect(() => {
  //   const fetchToken = async () => {
  //     if (!isAuthenticated) return;

  //     try {
  //       const token = await getAccessTokenSilently();
  //       console.log("✅ Token:", token);
  //     } catch (error) {
  //       console.error("❌ Token error:", error);
  //     }
  //   };

  //   fetchToken();
  // }, [isAuthenticated, getAccessTokenSilently]);

  const { isAuthenticated, isLoading, getAccessTokenSilently } = useAuth0();

  // 🔎 Post-login check: fetch ACCESS token (for your API audience) and verify 3 parts
  useEffect(() => {
    if (isLoading || !isAuthenticated) return;

    let alive = true;
    (async () => {
      try {
        const resp = await getAccessTokenSilently({
          authorizationParams: {
            audience: process.env.REACT_APP_AUTH0_AUDIENCE, // e.g. https://.../api
            scope: "read:is-paid",
          },
          detailedResponse: true,   // gives { access_token, expires_in, ... }
          cacheMode: "off",         // bypass any stale encrypted token
        });

        if (!alive) return;
        const at = resp?.access_token || "";
        const parts = at.split(".").length;
        console.log("[App] ACCESS token parts:", parts);       // ✅ expect 3
        try {
          const b64 = (s) => JSON.parse(atob(s.replace(/-/g, "+").replace(/_/g, "/")));
          console.log("[App] ACCESS header:", b64(at.split(".")[0])); // { alg: 'RS256', ... }
        } catch {}
        if (parts !== 3) {
          console.warn("[App] Not a JWS. Check audience/scope/provider config.");
        }
      } catch (e) {
        // Ignore typical SDK noise but log useful debug
        const msg = String(e?.error || e?.message || e);
        if (!/login_required|consent_required|missing authentication/i.test(msg)) {
          console.warn("[App] ACCESS token check failed:", msg);
        }
      }
    })();

    return () => { alive = false; };
  }, [isAuthenticated, isLoading, getAccessTokenSilently]);




  return (
    <LanguageProvider>
      <Router>
        <Auth0ProviderWrapper>
          <div className="app-container">
            <Navbar />
            <Switch>
              <Route exact path="/" component={Home} />
              <Route path="/courses" component={CoursesPage} />
              <Route path="/tutoring" component={TutoringPage} />
              <Route path="/lessons/:module/:lesson" component={LessonDetails} />
              <Route path="/callback" component={AuthCallback} />
              <Route path="/payment" component={Payment} />
              <Route path="/payment-investindo-nos-eua" component={PaymentInvestEua} />
              <Route path="/premium" component={PremiumPage} />
              <Route path="/quiz">
                <Quiz questions={financialGoalsQuestions} />
              </Route>
              
              {/* markdown blogs at /blog-guides */}
              <Route exact path="/blog-guides" component={BlogGuides} />
              <Route path="/blog-guides/:guideId" component={GuidesPage} />
              <Route path="/personal-finance" component={PersonalFinance} />
              <Route path="/stock-trade" component={StockTradingBasics} />
              <Route path="/investparabr" component={InvestParaBr} />
              <Route path="/retirementcalculator" component={RetirementCalculator}/>
              <Route path="/careers" component={CareersPage} />
              <Route path="/tutor-portal">
                <Redirect to="/" />
              </Route>

            </Switch>
            <Footer />
          </div>
        </Auth0ProviderWrapper>
      </Router>
    </LanguageProvider>
  );
};

export default App;

